export default "__VITE_ASSET__CR4apSVs__"